import { SyntaxTree } from './getWikiSyntaxTree';

type FormatLastPartChildrenType = (children: SyntaxTree) => SyntaxTree;

/**
 * Функция, которая изменяет сформированный children, удаляет с начала и конца списка пустые строки (br)
 */
export const trimSyntaxTree: FormatLastPartChildrenType = (children) => {
  let startIndex = 0;
  let endIndex = children.length - 1;
  let flagStartBreak = false;
  let flagEndBreak = false;
  const checkEmptyLine = (child: SyntaxTree[0]) =>
    (typeof child === 'string' && child.trim() === '') || (typeof child === 'object' && child.tagName === 'br');

  while (!flagStartBreak || !flagEndBreak) {
    if (!flagStartBreak) {
      const startItem = children[startIndex];

      if (checkEmptyLine(startItem)) {
        startIndex++;
      } else {
        flagStartBreak = true;
      }
    }

    if (!flagEndBreak) {
      const endItem = children[endIndex];

      if (checkEmptyLine(endItem)) {
        endIndex--;
      } else {
        flagEndBreak = true;
      }
    }
  }

  return children.slice(startIndex, endIndex + 1);
};
